<template>
  <el-container>
    <el-header>
      <myHeader></myHeader>
    </el-header>
    <el-main>
      <el-form :inline="true" :model="form" @submit.native.prevent>
        <el-row>
          <el-col :span=24 style="text-align:left">
            <el-form-item label="状态">
              <el-select v-model="form.zt" @change="changeZt">
                <el-option label="进行中" value="1"></el-option>
                <el-option label="未开始" value="0"></el-option>
                <el-option label="已完成" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="">
              <el-input v-model="form.ksmc" style="width:400px" placeholder="请输入考试名称" @keyup.enter.native="query()"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="query()">查询</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div v-if="tableData.length > 0" style="text-align: left;display: flex;flex-wrap: wrap;">
        <div class="examCard" v-for="(data, k) in tableData" :key="k">
          <div><span style="font-size: 15px;">{{data.ksmc}}</span></div>
          <el-divider class="divider-mar"></el-divider>
          <div v-if="form.zt === '2' && data.lsh">
            <div class="cardLabel">答卷时间:</div>
            <div class="cardData">
              &nbsp;&nbsp;&nbsp;&nbsp;{{data.kskskssj}}
              <br/>
              至&nbsp;{{data.ksksjssj || '---'}}
            </div>
          </div>
          <div v-else>
            <div class="cardLabel">考试时间:</div>
            <div class="cardData">
              &nbsp;&nbsp;&nbsp;&nbsp;{{data.kfqssj}}
              <br/>
              至&nbsp;{{data.kfjssj}}
            </div>
          </div>
          <div v-if="form.zt === '2' && data.lsh">
            <div class="cardLabel">答卷时长:</div>
            <div class="cardData">{{data.kskssc || '---'}}</div>
          </div>
          <div v-else>
            <div class="cardLabel">考试时长:</div>
            <div class="cardData">{{data.djsj + '分'}}</div>
          </div>
          <div>
            <div class="cardLabel">试卷总分:</div>
            <div class="cardData">{{data.sjzf}}分</div>
          </div>
          <template v-if="form.zt === '2' && data.lsh">
            <div>
              <div class="cardLabel">考试成绩:</div>
              <div class="cardData" v-if="data.yxbz === '1'" :style="'阅卷中,-'.indexOf(data.zzdf) !== -1 ? 'color: blue' : 'font-weight: bold'">{{data.zzdf}}</div>
              <div class="cardData" v-else>-</div>
            </div>
            <div>
              <div class="cardLabel">考试结果:</div>
              <div class="cardData" v-if="data.yxbz === '1' && data.jgfs" :style="`color: ${'阅卷中,-'.indexOf(data.zzdf) !== -1 ? 'blue' : (data.zzdf >= data.jgfs ? 'green' : 'red')}`">{{'阅卷中,-'.indexOf(data.zzdf) !== -1 ? data.zzdf : (data.zzdf >= data.jgfs ? '通过' : '不通过')}}</div>
              <div class="cardData" v-else>-</div>
            </div>
          </template>
          <template v-else>
            <div>
              <div class="cardLabel">可考次数:</div>
              <div class="cardData">{{data.sycs == null ? '不限制' : data.sycs + '次'}}</div>
            </div>
          </template>
          <div v-if="form.zt === '1'" style="text-align: right;">
            <el-button type="warning" v-if="data.bkcs > 0" @click="toExamBaseInfo(data.ksid, data.sqlsh)">进入补考</el-button>
            <el-button type="primary" v-else :disabled="data.sycs === 0" @click="toExamBaseInfo(data.ksid, data.sqlsh)">进入考试</el-button>
            <!-- :class="`button ${data.sycs === 0 ? 'disableButton' : 'examButton'}`" -->
          </div>
          <div v-if="form.zt === '2'" style="text-align: right;">
            <el-button v-if="data.lsh && data.yxbz === '1'" type="primary" @click="toExamResult(data.ksid, data.sjid, data.lsh)">查看结果</el-button>
            <el-button type="info" plain v-else-if="data.lsh && data.yxbz === '9'" style="color: #00000078;" disabled>已作废</el-button>
            <el-button type="info" plain v-else-if="!data.lsh" style="color: #00000078;" disabled>考试已结束</el-button>
          </div>
        </div>
      </div>
      <div v-else style="text-align:center">
        <p style="font-size: 20px;">没有相关数据</p>
      </div>
      <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="pageSize"
            background
            layout="total, prev, pager, next"
            :total="totalNum">
          </el-pagination>
    </el-main>
  </el-container>
</template>
<script>
import myHeader from '@/components/myHeader2'
import { baseURL } from '../../assets/js/config.js'
import { getExamList } from '@/api/examinee'
export default {
  data () {
    return {
      loading: false,
      noMore: false,
      form: {
        ksmc: '',
        zt: '1'
      },
      currentPage: 1,
      pageSize: 4,
      totalNum: 0,
      tableData: []
    }
  },
  components: {
    myHeader
  },
  methods: {
    // 进入考试
    toExamBaseInfo (ksid, sqlsh) {
      const auth = this.$store.state.mobile.auth
      const sqlshStr = sqlsh ? '&sqlsh=' + sqlsh : ''
      const ksUrl = baseURL + '/index.html/#/exam/baseInfo?ksid=' + ksid + sqlshStr + '&auth=' + encodeURIComponent(auth)
      window.open(ksUrl, '_blank')
    },
    // 查看考试结果
    toExamResult (ksid, sjid, lsh) {
      const auth = this.$store.state.mobile.auth
      const ksUrl = baseURL + '/index.html/#/exam/result?ksid=' + ksid + '&sjid=' + sjid + '&lsh=' + lsh + '&auth=' + encodeURIComponent(auth)
      window.open(ksUrl, '_blank')
    },
    changeZt (zt) {
      this.form.zt = zt
      this.query()
    },
    handleCurrentChange (val) {
      this.query(val)
    },
    query (currentPage = 1) {
      this.currentPage = currentPage
      const params = Object.assign({ pageNo: this.currentPage, pageSize: this.pageSize }, this.form)
      getExamList(params).then(res => {
        this.$http.callback(res, () => {
          const data = res.data
          this.tableData = data.list
          this.totalNum = data.count
        })
      })
    }
  },
  created () {
    this.query()
  }
}
</script>
<style scoped>
  .searchDiv {
    width: calc(100% - 100px);
    text-align: left;
    background: white;
    display: inline-block;
    padding-right: 20px;
    border-radius: 20px;
  }
  .searchInput {
    width: calc(100% - 50px);
    border: 0;
    height: 30px;
    line-height: 30px;
  }
  .tabList {
    margin-top: 10px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .tabItem {
    width: 30%;
    text-align: center;
    font-size: 20px;
    color:#fff;
  }
  .tabSelect span {
    border-bottom: 3px solid #fff;
  }
  .examCard {
    display: inline-block;
    text-align: left;
    width: 45%;
    padding: 12px;
    margin: 8px 8px;
    line-height: 1.5em;
    font-size: 13px;
    background-color: #fefefe;
    border-radius: 4px;
  }
  .cardLabel {
    display: inline-block;
    width: 70px;
  }
  .cardData {
    display: inline-block;
    width: calc(100% - 80px);
    vertical-align: top;
  }
  .button {
    width: 80px;
    padding: 5px;
    font-size: 10px;
    border: 0;
    color: #fff;
    box-shadow: 0 2px 12px 0 #dab3b3;
  }
  .examButton {
    background: #0099FF;
  }
  .disableButton {
    background: #d7dde0;
  }
  .bkButton {
    background: rgb(255, 196, 0);
  }

  .divider-mar{
    margin: 12px 0px;
  }
</style>
